import React from "react";
import ReactDOM from "react-dom";
import { useLocation } from "react-router-dom";
import styles from "./PageBackground.module.scss";
import imagePaths from "../../constants/imagePaths";
import { ADMIN_ROUTES, OPERATIONAL_REPORT_ROUTES } from "../../constants/routeConfig";

const PageBackground = () => {
  const { pathname } = useLocation();

  const isOperationalReportRoute = OPERATIONAL_REPORT_ROUTES.includes(pathname);
  const isAdminRoute = ADMIN_ROUTES.includes(pathname);

  const isPrimaryBackgroundRoute =
    pathname === "/" ||
    pathname === "/homepage" ||
    pathname === "/landingscreen" ||
    pathname === "/locate";

  if (typeof document === "undefined" || isOperationalReportRoute || isAdminRoute) return null;
  return ReactDOM.createPortal(
    <div className={styles.backgroundLayer} aria-hidden="true">
      <div className={styles.blurRight} />
      <img
        src={imagePaths.pageBackground.lilacAurora}
        alt=""
        className={`${styles.lilacAurora} ${
          isPrimaryBackgroundRoute
            ? styles.lilacAuroraFullOpacity
            : styles.lilacAuroraDimmed
        }`}
      />
      <img
        className={styles.ellipesRight}
        src={imagePaths.common.icons.ellipseSmright}
        alt="Elipse"
      />

    </div>,
    document.body
  );
};

export default PageBackground;
